// extracted by mini-css-extract-plugin
export default {"cropArea":"ImageCropModal_cropArea__YDJ41","actions":"ImageCropModal_actions__ViF-1"};